import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import DEFAULT_THEME from '../../consts/theme';
import { RootState } from '../store';

import { ConfigState } from './configTypes';

const initialState: ConfigState = {
  theme: DEFAULT_THEME,
};

const configSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    changeTheme: (
      state,
      action: PayloadAction<Record<string, Record<string, string | number>>>
    ) => {
      state.theme = { ...state.theme, ...action.payload };
    },
  },
});

export const { changeTheme } = configSlice.actions;

export const selectTheme = (state: RootState) => state.config.theme;

export default configSlice.reducer;
